  import React from 'react';

const VendorSection = () => {
  const features = [
    {
      number: "01",
      title: "Exclusive Member Discounts",
      description: "Exclusive deals on parts, detailing, and accessories for Car Hangout members."
    },
    {
      number: "02",
      title: "Trusted Vendor Network",
      description: "Connect with trusted garages, shops, and automotive experts."
    },
    {
      number: "03",
      title: "Boost Your Builds",
      description: "Find the parts and services you need to take your ride to the next level."
    },
    {
      number: "04",
      title: "Community Reviews & Ratings",
      description: "Get trusted feedback from fellow car enthusiasts before choosing vendors."
    }
  ];

  return (
    <section className="bg-[#0B0B0B] text-white pb-12 md:pb-16 lg:pb-24 pt-0  px-4 md:px-8 lg:px-16 xl:px-24 relative overflow-hidden xxs:-mt-16 mt-16">
      {/* Background decorative elements - stars/glints */}
      {/* <div className="absolute top-0 left-0 w-32 h-32 opacity-20 pointer-events-none">
        <div className="absolute top-8 left-8 w-2 h-2 bg-white rounded-full"></div>
        <div className="absolute top-12 left-16 w-1 h-1 bg-white rounded-full"></div>
        <div className="absolute top-16 left-12 w-1.5 h-1.5 bg-white rounded-full"></div>
      </div>
      <div className="absolute bottom-0 right-0 w-32 h-32 opacity-20 pointer-events-none">
        <div className="absolute bottom-8 right-8 w-2 h-2 bg-white rounded-full"></div>
        <div className="absolute bottom-12 right-16 w-1 h-1 bg-white rounded-full"></div>
        <div className="absolute bottom-16 right-12 w-1.5 h-1.5 bg-white rounded-full"></div>
      </div> */}

      {/* Main Container */}
      <div className="max-w-7xl mx-auto xs:mt-30">
        <div className="grid grid-cols-1 sm:-mt-10  xxs:-mt-1 lg:grid-cols-2 gap-8 lg:gap-2 xl:gap-5">
          
          {/* Left Section: Text Content */}
          <div className="w-full flex flex-col justify-center relative md:ml-[-20px] lg:ml-[-500px] xxs:-mt-10 xl:-ml-[700px] 2xl:-ml-[830px] mt-2 md:mt-6 lg:mt-24 sm:-mt-4 order-2 lg:order-1 px-4 sm:px-6 lg:px-8 vendor-text">
            <div className="mb-8 lg:mb-6">
              <h3 className="text-2xl md:text-3xl lg:text-2xl xl:text-3xl font-semibold text-white uppercase tracking-wider font-noto-sans leading-tight mb-3 xl:mb-3 md:mb-4 text-left whitespace-normal  2xl:whitespace-nowrap max-w-none" style={{ transform: 'scaleY(1.3)'  }}>
                Vendor Lane – Deals That Drive <span className="text-orange-700 2xl:text-wrap">Your Passion</span>
              </h3>
              <p className="text-gray-200 text-base md:text-base lg:text-base xl:text-lg  font-noto-sans leading-relaxed max-w-3xl sm:-mb-2 xl:max-w-4xl">
                <span className=''>Explore trusted sellers for top car parts, accessories, and upgrades. Compare, shop, and
                {/* <br className="hidden xl:block" /> */}
                gear up all in one place.
                </span>
              </p>
            </div>
            <style>{`
              @media (min-width: 1150px) and (max-width: 1309px) {
                .vendor-text {
                  margin-left: -600px !important;
                }
              }
              @media (min-width: 1280px) and (max-width: 1369px) {
                .vendor-text {
                  margin-left: -640px !important;
                }
              
              }
              @media (min-width: 1316px) and (max-width: 1441px) {
                .vendor-image {
                  transform: scale(1.1) !important;
                  margin-left: -4% !important;
                }
              }
            `}</style>
            
            <div className="space-y-4 md:space-y-6 lg:space-y-3 ">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="flex w-full items-start gap-3 md:gap-4 lg:gap-5 pb-1 md:pb-3"
                  style={
                    index < features.length - 1
                      ? {
                          borderBottom: '1px solid #FFFFFF0D',
                          marginRight: '-56px',
                          paddingRight: '56px'
                        }
                      : {}
                  }
                >
                  <div className="flex-shrink-0 mt-1 ">
                    <div
                      className="w-6 h-6 md:w-8 md:h-8  lg:w-8 lg:h-8 rounded flex items-center justify-center aspect-square"
                      style={{ backgroundColor: '#141415', border: '1px solid #FFFFFF0D' }}
                    >
                      <span className="text-white font-bold text-[11px] md:text-xs lg:text-xs font-noto-sans">
                        {feature.number}
                      </span>
                    </div>
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-white opacity-90 text-base md:text-lg lg:text-base font-regular mb-2 md:mb-3 font-noto-sans leading-tight 2xl:whitespace-nowrap break-words">
                      {feature.title}
                    </h3>
                    <p className="text-gray-200 text-xs md:text-sm lg:text-base font-regular leading-relaxed font-noto-sans break-words whitespace-normal 2xl:whitespace-nowrap">
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Section: Vendor Image Box */}
          <div className="w-full relative xl:ml-[600px] lg:ml-[480px]  mt-8 md:mt-12 lg:mt-16 mb-8 md:mb-0 order-1 lg:order-2 px-4 sm:px-  lg:px-8">
            {/* Vendor image for small screens (without box) */}
            <div className="md:hidden relative w-full">
              <div className="relative w-full h-auto flex justify-center items-center">
                <img 
                  src="/asset/vendors.png" 
                  alt="Vendor Showcase" 
                  className="vendor-image w-full h-auto object-contain rounded-2xl transform scale-[1.25] sm:scale-[1.1]"
                  style={{
                    maxHeight: '540px',
                    minHeight: '200px'
                  }}
                />
              </div>
            </div>

            {/* Background box behind the entire section - hidden on small screens */}
            <div className="hidden md:flex relative bg-[#0B0B0B] rounded-2xl lg:rounded-3xl p-6 md:p-8 lg:p-10 shadow-2xl backdrop-blur-sm w-[100%] md:w-[100%] lg:w-[110%] flex-col items-center -mr-2 md:mr-0 lg:ml-6 2xl:ml-10 main-box">
              {/* Vendor image */}
              <div className="mb-8 relative w-full">
                <div className="relative w-full h-auto flex justify-center items-center">
                  <img 
                    src="/asset/vendors.png" 
                    alt="Vendor Showcase" 
                    className="vendor-image w-full h-auto object-contain rounded-2xl transform scale-[1.25] sm:scale-[1.1] md:scale-[1.05] lg:scale-[1.15] xl:scale-[1.25] 2xl:scale-[1.3]"
                    style={{
                      maxHeight: '540px',
                      minHeight: '200px'
                    }}
                  />
                  <style>{`
                    @media (min-width: 600px) and (max-width: 767px) {
                      .main-box {
                        width: 100% !important;
                        transform: scale(0.95) !important;
                        margin-right: 0 !important;
                      }
                    }
                    @media (min-width: 768px) and (max-width: 1023px) {
                      .main-box {
                        width: 100% !important;
                        transform: scale(0.95) !important;
                        margin-right: 0 !important;
                      }
                    }
                    @media (min-width: 1280px) {
                      .vendor-image {
                        margin-left: 8% !important;
                      }
                    }
                    @media (min-width: 1230px) and (max-width: 1441px) {
                      .vendor-image {
                        margin-left: -4% !important;
                        transform: scale(1.1) !important;
                      }
                    }
               
                  `}</style>
                </div>
              </div>
              
              {/* Vendor Details */}
            
            </div>
          </div>
           
          </div>
        </div>
    
    </section>
  );
};

export default VendorSection;

